export const MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
export const IOS_REGEX = /iPad|iPhone|iPod/
export const ANDROID_REGEX = /android/i
